import Files from './Files.vue';

export default Files;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/itemsblock/components/files/index.ts